import React, {useState} from "react";
import searchicon from '../Assets/images/search_primary.png';
import { Typography } from "@mui/material";
import BiztantuSearchDialog from "./BiztantuSearchDialog";
import { handleValidateCodevalue } from "../Utility/constant";
import TextFiledWithLabel from "./TextFieldWithLabel";
import { useSelector } from "react-redux";
import SelectBoxWithLabel from "./SelectBoxWithLable";
import { StyledSearchContainer } from "./Styled";

const BiztantuSearch = ({ownerlistdropdown ,children , handleReset,entityDetails,handleSearch,showOwner = false }) => {
    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData)
    const [dialog, setDialog] = useState({
        isOpen: false,
        data: null
    });

    const ignoredFields = ['ownerId', 'updatedFrom', 'updatedTo', 'status','selectedOwner','productType','runOnce','ownerName'];

    const extraFieldCount = Object.keys(entityDetails || {}).filter(key => {
    const value = entityDetails[key];
    return !ignoredFields.includes(key) && value != null && value !== "";
    });
    const count = extraFieldCount?.length


    const handleOpenDialog = () => {
        setDialog({
            ...dialog,
            isOpen: true
        });
    }

    const handleCloseDialog = () => {

         setDialog({
            ...dialog,
            isOpen: false
        });

    }




    return (
        <>
           <StyledSearchContainer sx ={{gap : 2, marginTop: "", backgroundColor: "white"}}>
                <TextFiledWithLabel
                    disabled = {true}
                    id="updatedFrom"
                    name="updatedFrom"
                    className="creationDate"
                    type="date"
                    value = {entityDetails?.updatedFrom}
                    label={handleValidateCodevalue(internationalise,"COMMON_UPDATED_FROM")}
                />
                <TextFiledWithLabel
                    disabled = {true}
                    id="updatedTo"
                    name="updatedTo"
                    className="creationDate"
                    type="date"
                    value = {entityDetails?.updatedTo}
                    label={handleValidateCodevalue(internationalise,"COMMON_UPDATED_TO")}
                />
                {showOwner &&
                 <TextFiledWithLabel
                    disabled = {true}
                    label={handleValidateCodevalue(internationalise,"COMMON_SEARCH_OWNER")}
                    value={handleValidateCodevalue(internationalise,(entityDetails?.ownerName || ""))}
                    className="creationDate"
                />
                }
                <TextFiledWithLabel
                    disabled = {true}
                    className="creationDate"
                    label={handleValidateCodevalue(internationalise,"COMMON_SEARCH_STATUS")}
                    value={handleValidateCodevalue(internationalise,entityDetails?.status)}
                />
                <Typography onClick={handleOpenDialog} variant="body1" sx={{color: "#9F9F9F", cursor: "pointer"}}>
                    {count>0 ? `+${count} ${handleValidateCodevalue(internationalise,"COMMON_SEARCH_COUNT_MORE")}` : ""}
                </Typography>
                <div className="height_100">
                    <img onClick={handleOpenDialog} src={searchicon} style={{cursor: "pointer", height: "40px"}}/>
                </div>
            </StyledSearchContainer> 

            <BiztantuSearchDialog
                handleReset = {handleReset}
                handleSearch = {handleSearch}
                data = {dialog}
                handleCloseDialog = {handleCloseDialog}
            >
                {children}
            </BiztantuSearchDialog>
        </>
    )
}

export default BiztantuSearch;